import { PUBLIC_SITE_NAME } from '$env/static/public';
import type { MetaTagsProps } from 'svelte-meta-tags';

export const load = ({ url }) => {
	const defaultTags = {
		title: 'Tempat Langganan Buku Online Terlengkap',
		titleTemplate: `%s | ${PUBLIC_SITE_NAME}`,
		description: `${PUBLIC_SITE_NAME} adalah situs penyedia buku online terlengkap.`,
		canonical: new URL(url.pathname, url.origin).href,
		siteName: PUBLIC_SITE_NAME,
		image: `${url.origin}/api/og/basic?text=Tempat Langganan Buku Online Terlengkap`
	};

	const baseMetaTags = Object.freeze({
		title: defaultTags.title,
		titleTemplate: defaultTags.titleTemplate,
		description: defaultTags.description,
		canonical: defaultTags.canonical,
		keywords: [
			PUBLIC_SITE_NAME.toLowerCase(),
			'tempat langganan buku',
			'langganan buku',
			'buku',
			'buku online'
		],
		openGraph: {
			type: 'website',
			url: defaultTags.canonical,
			title: defaultTags.title,
			description: defaultTags.description,
			siteName: defaultTags.siteName,
			locale: 'id_ID',
			images: [
				{
					url: defaultTags.image,
					width: 1200,
					height: 630,
					alt: defaultTags.title,
					secureUrl: defaultTags.image,
					type: 'image/png'
				}
			]
		},
		twitter: {
			handle: '@YapindoOfficial',
			site: '@YapindoOfficial',
			cardType: 'summary_large_image',
			title: defaultTags.title,
			description: defaultTags.description,
			image: defaultTags.image,
			imageAlt: defaultTags.title
		},
		facebook: {
			appId: '1907470439764742'
		},
		additionalMetaTags: [
			{
				property: 'application-name',
				content: PUBLIC_SITE_NAME
			},
			{
				property: 'google-site-verification',
				content: 'U1kAi79L5lP-pJtk_IcgwS7pm48CoyiUTdkvf1AUmAk'
			}
		]
	}) as MetaTagsProps;

	return { baseMetaTags };
};
